import { apiJson } from './client.js'

export function trafficApi(path, { agencyId, params = {}, method = 'GET', body } = {}) {
  const query = new URLSearchParams()
  if (agencyId) query.set('agency_id', agencyId)
  Object.entries(params).forEach(([key, value]) => {
    if (value !== '' && value !== undefined && value !== null) query.set(key, value)
  })
  return apiJson(`/admin/traffic-intelligence/${path}?${query}`, {
    method, ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  }, 'Unable to load Traffic Intelligence')
}
